// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.root {
  display: inline-block;
  vertical-align: top;
  margin: 0 5px 5px 0;
  white-space: nowrap;
}

.root:last-child {
  margin-right: 0;
}

/* TODO: remove all this child selector and tag selector stuff. */

.root > div > button {
  margin-right: 0;
  border-radius: 0;
}

.root > div > button:focus {
  position: relative;
  z-index: 1;
}

.root > div:first-child > button {
  border-top-left-radius: 2px;
  border-bottom-left-radius: 2px;
}

.root > div + div > button {
  border-left-width: 0;
}

.root > div:last-child > button {
  border-top-right-radius: 2px;
  border-bottom-right-radius: 2px;
}
`, "",{"version":3,"sources":["webpack://./node_modules/react-rte/lib/ui/ButtonGroup.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA,iEAAiE;;AAEjE;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC","sourcesContent":[".root {\n  display: inline-block;\n  vertical-align: top;\n  margin: 0 5px 5px 0;\n  white-space: nowrap;\n}\n\n.root:last-child {\n  margin-right: 0;\n}\n\n/* TODO: remove all this child selector and tag selector stuff. */\n\n.root > div > button {\n  margin-right: 0;\n  border-radius: 0;\n}\n\n.root > div > button:focus {\n  position: relative;\n  z-index: 1;\n}\n\n.root > div:first-child > button {\n  border-top-left-radius: 2px;\n  border-bottom-left-radius: 2px;\n}\n\n.root > div + div > button {\n  border-left-width: 0;\n}\n\n.root > div:last-child > button {\n  border-top-right-radius: 2px;\n  border-bottom-right-radius: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
